import styled from 'styled-components';

const NavigationLinkDropdown = styled.div`
  div.sub__menu--wrapper {
    padding: 0;

    &:hover > ul.sub__menu,
    &:focus-within > ul.sub__menu {
      opacity: 1;
      visibility: visible;
      width: 100vw;
      margin: auto;
      background-color: white;
      left: 50%;
      top: inherit;
      overflow: hidden;
      padding: 2rem;
      border-radius: 0 0 5px 5px;
      overflow-y: hidden;
      transform: translate(-50%, 0);
      z-index: 998;
      max-height: 500px;
      transition-delay: 0.5s;
    }

    &:hover + .overlay,
    &:focus-within + .overlay {
      background: rgba(0, 0, 0, 0.33);
      height: 100vh;
      width: 100vw;
      position: absolute;
      left: 50%;
      top: inherit;
      transform: translate(-50%, 0);
      z-index: 997;
      margin-top: 1.5rem;
      transition-delay: 0.5s;
    }

    .show-inactive {
      display: inline-flex;
      font-size: 0.875rem;
      text-decoration: none !important;
      color: ${(props: any) => props.theme.textColor};
      margin: auto;

      @media (max-width: 1080px) {
        font-size: 0.75rem;
      }

      @media (max-width: 992px) {
        display: none;
      }
    }

    .show-active {
      display: none;
      opacity: 0;
    }

    &:focus-within,
    &:focus {
      .show-active {
        transform: rotate(180deg);
        transition-delay: 0s;
        text-decoration: none !important;
        display: block;
      }

      .show-inactive {
        transition-delay: 0s;
        text-decoration: none !important;
        display: block;
      }
    }

    &:hover {
      .show-active {
        transform: rotate(180deg);
        transition-delay: 0.5s;
        text-decoration: none !important;
      }

      .show-inactive {
        display: none;
        transition-delay: 0.5s;
        text-decoration: none !important;
      }
    }

    &:focus-within,
    &:focus,
    &:hover {
      .show-active {
        display: inline-flex;
        font-size: 0.875rem;
        opacity: 1;
        width: auto;
        color: ${(props: any) => props.theme.textColor};
        margin: auto;

        @media (max-width: 1080px) {
          font-size: 0.75rem;
        }

        @media (max-width: 992px) {
          display: none;
        }
      }

      .show-inactive {
        display: none;
        opacity: 0;
      }
    }
  }

  a.nav__anchor,
  button.anchor__has-submenu {
    text-decoration: none;
    color: ${(props: any) => props.theme.textColor};
    background: transparent;
    border: none;
    font-family: ${(props: any) => props.theme.bodyFont};
    display: inline-flex;

    &.active,
    &:hover {
      text-decoration: none !important;

      .display {
        text-decoration: underline;
        color: ${(props: any) => props.theme.linkColor};
      }
    }
  }

  button {
    padding: 0;
  }

  .sub__menu {
    position: absolute;
    visibility: hidden;

    div.sub__menu--show {
      border-top: 1px solid #e5e5e5;
    }

    div.sub__menu--content {
      padding: 1.5rem 0 5rem 0;
      justify-content: space-evenly;
      flex-wrap: wrap;
      flex-direction: column;
      display: flex;
      height: auto;
      max-height: 500px;
      flex-grow: 1;

      h2.menu__header {
        font-size: 0.875rem;
        font-family: ${(props: any) => props.theme.bodyFont};
        margin: 0;
        font-weight: 600;
      }

      li {
        margin: 0;
        flex: 1;
        padding: 0;
      }
    }
  }

  .sub__menu--column-content {
    margin-bottom: 1rem;
  }
`;

export default NavigationLinkDropdown;
